export default __webpack_public_path__ + "static/media/check_icon.90ab8871.svg";